import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#fe8228",
        secondary: "#fad7c0",
        accent: "#8c9eff",
        error: "#b71c1c",
        highlight: "#fbe34e",
        alartGentle: "#11264D",
        styleTag: "#accfc2"
      }
    }
  }
});
